export const NAV = {
    logo: "nav-logo",
    linkMenu: "nav-link-menu",
    linkManifesto: "nav-link-manifesto",
    linkContatti: "nav-link-contatti",
    linkDove: "nav-link-dove",
    ctaCall: "nav-cta-call",
};

export const HERO = {
    section: "hero-section",
    titleLine1: "hero-title-line-1",
    titleLine2: "hero-title-line-2",
    subtitle: "hero-subtitle",
    ctaCall: "hero-cta-call",
    ctaMenu: "hero-cta-menu",
    floatingSign: "hero-floating-sign",
    floatingPizza: "hero-floating-pizza",
};

export const MANIFESTO = {
    section: "manifesto-section",
    chapter: (id) => `manifesto-chapter-${id}`,
};

export const MENU = {
    section: "menu-section",
    tab: (name) => `menu-tab-${name}`,
    item: (name) => `menu-item-${name}`,
};

export const DOVE = {
    section: "dove-section",
    map: "dove-map",
    address: "dove-address",
};

export const CONTATTI = {
    section: "contatti-section",
    phone: "contatti-phone",
    whatsapp: "contatti-whatsapp",
    hours: "contatti-hours",
};

export const WHATSAPP = {
    float: "whatsapp-float-btn",
};

export const MARQUEE = {
    strip: "editorial-marquee",
};

export const FOOTER = {
    section: "footer-section",
};
